export function isDisplayablePrice(price: number | null | undefined): price is number {
  return typeof price === 'number' && Number.isFinite(price) && price > 0
}

export function hasDisplayablePackagePrice<T extends { price?: number | null }>(pkg?: T | null): pkg is T & { price: number } {
  return isDisplayablePrice(pkg?.price)
}
